import React, {Component} from "react";
import {Var} from "../../../App";
import PropTypes from "prop-types";
import './index.css';

class Check extends Component {
    constructor (props) {
        super(props);

        this.state = {
            disabled: false,
            readOnly: false,
            checked: props.checked,
            id: `inp_${Var.shuffle('string', 6)}`
        };

        this.ref = {
            input: React.createRef()
        };
    }

    static defaultProps = {
        className: null,
        style: {},
        align: 'right',
        direction: 'rtl',
        label: null,
        title: null,
        id: null,
        name: null,
        readOnly: false,
        disabled: false,
        checked: false,
        onChange: _ => null,
        onClick: _ => null
    };

    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        align: PropTypes.oneOf(['left', 'center', 'right']),
        direction: PropTypes.oneOf(['ltr', 'rtl']),
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        title: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        readOnly: PropTypes.bool,
        disabled: PropTypes.bool,
        checked: PropTypes.bool,
        onChange: PropTypes.func,
        onClick: PropTypes.func
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        if (this.props.checked !== nextProps.value)
            nextState.checked = nextProps.checked;

        return this.state.disabled !== nextState.disabled ||
            this.state.readOnly !== nextState.readOnly ||
            this.state.checked !== nextState.checked ||
            this.props.readOnly !== nextProps.readOnly ||
            this.props.disabled !== nextProps.disabled ||
            this.props.className !== nextProps.className ||
            this.props.checked !== nextProps.checked;
    }

    render () {
        const {state, props} = this;
        const cls = ['Check', props.align, props.direction];
        const readOnly = state.readOnly || props.readOnly;
        const disabled = state.disabled || props.disabled;
        const id = props.id || state.id;

        props.className && cls.push(props.className);
        readOnly && cls.push('read-only');
        disabled && cls.push('disabled');

        return <div className={cls.join(' ')} style={props.style} title={props.title}>
            <input ref={this.ref.input}
                   type={'checkbox'}
                   className={'Check-control'}
                   id={id}
                   name={props.name || id}
                   placeholder={props.placeholder}
                   readOnly={readOnly}
                   disabled={disabled}
                   checked={props.checked}
                   onChange={this.inputChangeHandler.bind(this)}
                   onClick={this.inputClickHandler.bind(this)}
                   style={{direction: props.direction}}/>
            <label className={'Check-label'} htmlFor={id}>{props.label}</label>
        </div>;
    };

    inputChangeHandler (event) {
        const {props} = this;
        let checked = event.target.checked;

        if (!(props.readOnly || props.disabled)) {
            this.setState({checked: checked}, _ => {
                props.onChange(checked);
            });
        }
    };

    inputClickHandler () {
        this.props.onClick();
    }

    disabled (disabled = false) {
        this.setState({disabled});
    }

    readOnly (readOnly = false) {
        this.setState({readOnly});
    }

    value () {
        const {state} = this;

        return state.checked ? state.checked : false;
    }
}

export default Check;